import './App.css';

import Main from './components/Main/Main';
import Question from './components/Questions/Question';

function App() {
  return (
    <div className="App">
      <Main></Main>
      <Question></Question>
    </div>
  );
}

export default App;
